module.exports = __webpack_public_path__ + "static/img/plastpall.3db78a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plastpall.jpg
// module id = AoJP
// module chunks = 1